import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  style: {"margin":"auto","background":"none","display":"block","shape-rendering":"auto"},
  width: "200px",
  height: "200px",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "38",
      "stroke-width": "10",
      stroke: "#86bc4d",
      "stroke-dasharray": "59.690260418206066 59.690260418206066",
      fill: "none",
      "stroke-linecap": "round"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        dur: "4.166666666666666s",
        repeatCount: "indefinite",
        keyTimes: "0;1",
        values: "0 50 50;360 50 50"
      })
    ], -1),
    _createElementVNode("circle", {
      cx: "50",
      cy: "50",
      r: "27",
      "stroke-width": "10",
      stroke: "currentColor",
      "stroke-dasharray": "42.411500823462205 42.411500823462205",
      "stroke-dashoffset": "42.411500823462205",
      fill: "none",
      "stroke-linecap": "round"
    }, [
      _createElementVNode("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        dur: "4.166666666666666s",
        repeatCount: "indefinite",
        keyTimes: "0;1",
        values: "0 50 50;-360 50 50"
      })
    ], -1)
  ])))
}
export default { render: render }